import React from 'react';
import { Trans } from '@lingui/macro';

// Body content for the lifecycle-sync info drawer. The rules it describes live in
// the API cascades (SharedSettings::BaseCascade and friends), so keep this in step
// with them: the flag gates lifecycle actions in both directions and deliberately
// leaves attribute mapping alone.
const SyncOptOutInfoContent = () => (
  <>
    <p>
      <Trans>
        Enabling, disabling or removing this location also applies to the other
        integrations in its group.
      </Trans>
    </p>

    <h4>
      <Trans>Included</Trans>
    </h4>
    <ul>
      <li>
        <Trans>
          Enabling, disabling or removing this location here does the same to
          this location in every other integration of its Shared Setting.
        </Trans>
      </li>
      <li>
        <Trans>
          The reverse also holds: the same actions taken from any other
          integration in the group reach this location.
        </Trans>
      </li>
      <li>
        <Trans>
          Enabling is blocked for an integration still missing required location
          attributes — that integration is reported instead of being switched on
          with incomplete data.
        </Trans>
      </li>
    </ul>

    <h4>
      <Trans>Excluded</Trans>
    </h4>
    <ul>
      <li>
        <Trans>
          Enable, disable and remove stop travelling in both directions for this
          location: it no longer moves the group, and the group no longer moves
          it.
        </Trans>
      </li>
      <li>
        <Trans>
          Use it when one dealer has to deviate from its group — a location that
          must stay off in a single integration, for example — without breaking
          the link for everyone else.
        </Trans>
      </li>
    </ul>

    <h4>
      <Trans>What it does not change</Trans>
    </h4>
    <ul>
      <li>
        <Trans>
          Attribute mapping is untouched. The location stays in the Shared
          Setting and mapped values keep flowing as configured.
        </Trans>
      </li>
      <li>
        <Trans>
          The setting applies to this location in this integration only. Every
          other location of the integration, and this same location in other
          integrations, each carry their own.
        </Trans>
      </li>
      <li>
        <Trans>
          It cannot pre-empt an addition. A location that is not configured in
          an integration yet has no setting there, so the group can still add it
          — exclude it after it appears.
        </Trans>
      </li>
    </ul>
  </>
);

export default SyncOptOutInfoContent;
